/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Hero_TitleInputs */

const en_hub_hero_title = /** @type {(inputs: Hub_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works with the tools you already use`)
};

const id_hub_hero_title = /** @type {(inputs: Hub_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekerja dengan alat yang sudah Anda pakai`)
};

/**
* | output |
* | --- |
* | "Works with the tools you already use" |
*
* @param {Hub_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_hero_title = /** @type {((inputs?: Hub_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_hero_title(inputs)
	return en_hub_hero_title(inputs)
});